"use strict";

var _interopRequireDefault = require("D:/www/git/new-multiple-merchant-vue/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getToken = getToken;
exports.removeToken = removeToken;
exports.setToken = setToken;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var TokenKey = 'merchantToken';
function getToken() {
  // 只从 Cookie 读取，避免循环依赖
  // store 同步逻辑在 permission.js 中处理
  return _jsCookie.default.get(TokenKey);
}
function setToken(token) {
  return _jsCookie.default.set(TokenKey, token, {
    domain: '.zszhenhuixuan.com',
    path: '/',
    expires: 1 // 1天过期
  });
}
function removeToken() {
  // 删除Cookie时需要指定相同的domain和path，否则删除不掉
  return _jsCookie.default.remove(TokenKey, {
    domain: '.zszhenhuixuan.com',
    path: '/'
  });
}